import { useTranslation } from '@sib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@sib/ui';
import { TOS_CONTENT } from './TermsOfServiceModal.content';
import { useScrolledToBottom } from './TermsOfServiceModal.utils';

interface TermsOfServiceModalProps {
  open: boolean;
  onAccept: () => void;
}

export const TermsOfServiceModal = ({
  open,
  onAccept,
}: TermsOfServiceModalProps) => {
  const { t } = useTranslation();
  const { hasScrolledToBottom, handleScroll, handleContentMount } =
    useScrolledToBottom();

  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-181.75 gap-7 rounded-2xl px-12.5 py-7"
        onInteractOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader className="flex flex-col gap-7">
          <DialogTitle className="text-primary text-center text-xl">
            {t('termsOfServiceModal.title')}
          </DialogTitle>
          <DialogDescription className="text-primary text-center text-sm leading-5">
            {t('termsOfServiceModal.description')}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-semibold">
            {t('termsOfServiceModal.title')}
          </h3>
          <div
            ref={handleContentMount}
            onScroll={handleScroll}
            className="border-border max-h-[265px] overflow-y-auto rounded-sm border px-3.5 py-3 text-sm whitespace-pre-line"
          >
            {TOS_CONTENT}
          </div>
        </div>

        <div className="flex justify-center">
          <Button onClick={onAccept} disabled={!hasScrolledToBottom}>
            {t('termsOfServiceModal.accept')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
